import { addToWishList, removeFromWishList } from 'aster-foundation/core/epharmacy/wishlist/redux/actions';
import { REDIRECT_URI } from 'aster-foundation/core/common/utils/ApiConst';
import Image from 'next/image';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import dynamic from 'next/dynamic';
import { searchTermInsertion, searchTermProductInsertion } from 'aster-foundation/core/epharmacy/search/redux/actions';
import { errorHandling, getConfigurationActiveValueByName, getProductPath, getIsInstoreApp, errorHandlingEpharmacy, getImageUrlWithSize, checkIfCurrentLangIsArabic } from '@common/Utility/common-utils';
import {  BUNDLE_DEAL_PDP, BUNDLE_DEAL_PDP_UPDATED, IC_BOOKMARK, IC_BOOKMARK_CHECKED_GREEN, IC_POM_BADGE_CARDS, PRODUCT_CARD_DEFAULT } from '@common/Assets/images';
import { AE_GLOBAL, ASTER_PRODUCT_AVAILABILITY, PAYMENT_CURRENCY, PRODUCT_RATINGS_FLAG, SCHEDULED_EXPRESS_FLAG, WISHLIST_GA_EVENT, FLAGSMITH_KEYS, WISHLIST_TYPES, CART_TYPES, TEMPORARILY_OUT_OF_STOCK } from '@common/Utility/constants';
import { flagsmith } from '@common/Lib/Flagsmith';
import AddToCart from 'Epharmacy/Cart/AddToCart';
import { dataLayerSendEvent, getProductItemObjectEventFillersSelect, sendProductViewEvent, wishlistAddRemoveGAEvent } from 'Epharmacy/EpharmacyAnalytics';
import { EventEmitter } from '@common/Utility/eventEmitter';
import { sendEventToSmartLook } from '@common/Utility/smartlook';
import { ProductItemStyled } from './ProductItemStyled';
import ProductBadges from 'Epharmacy/ProductDetails/PDPComponents/ProductBadges';
import { sendLoginEvent } from '@common/Utility/analytics-utils';
import StarRatingNumberOnly from '../StarRatingNumberOnly/StarRatingNumberOnly';
import { useAuth } from '@common/AuthService';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';
import { getCurrency } from '@common/Constants/analytics';
import { getDataFromCookie } from 'aster-foundation/core/common/utils/cookieHelper';
import { isRTL, useTranslation } from '@common/i18n';
import { getLangCodeFromUrl } from '../../../../i18n';

const OfferTimeCounter = dynamic(() => import('../../../Epharmacy/ProductDetails/PDPComponents/OfferTimeCounter'));
const CustomModal = dynamic(() => import('../Modal/Modal'));

const ProductItem = (props) => {
  const {
    categoryImage,
    name,
    newPrice,
    actualPrice,
    badgeDetails,
    express,
    isFlash,
    deliverBy,
    currency,
    outOfStock,
    offerBadge,
    sku,
    availableStock,
    classname,
    sourceContainerTitle,
    product,
    isLoader,
    isInProductListingPage,
    deliveryText,
    pageName,
    sectionName,
    isMyCartPage,
    itemListId,
    isGlobalCarousel,
    itemListName,
    index,
    screen,
    pageType,
    avgRating,
    getProductIndex,
    facetResponse,
    lowestPriceLabel,
    isBundle,
    isScheduled,
    BundleDetails,
    BundleImage,
    referrerPage,
    hasRX,
    isOptics,
    shouldNotShowBundle=false,
    isPdpQuickView = false,
    lang = 'en',
    emptySphValues = () => {}
  } = props;
  const flashDeliveryFlag = flagsmith.getValue(FLAGSMITH_KEYS.FLASH_DELIVERY, { json: true });
  const { authCtx } = useAuth();
  const router = useRouter();
  const dispatch = useDispatch();
  const generateURL = useNavigationURL();
  const t = useTranslation();

  const myShoppingList = useSelector((state) => state?.app?.myShoppingListReducer);
  const wishListSkuIds = (myShoppingList?.wishList || [])?.map(listItem => listItem?.sku);

  const userZoneData = useSelector((state) => state?.epharmacy?.updateUserZone?.data?.additionalInfo)
  const userLogin = useSelector((state) => state?.astercore?.checkUserExist?.data?.entry?.[0]?.resource);
  const appConfigData = useSelector((state) => state?.astercore?.AppConfig?.data?.data);
  const currencyAppConfig = appConfigData?.find((c) => c.name === 'currency')?.value;

  const [isInWishList, setIsInWishList] = React.useState(wishListSkuIds?.find((skuId) => skuId === sku) || false);
  const [charLimit, setCharLimit] = React.useState();
  const [ratingsEnable, setRatingsEnable] = React.useState();
  const [showLoginModal, setShowLoginModal] = React.useState(false);
  const [pCurrency, setPCurrency] = React.useState(currency ?? PAYMENT_CURRENCY);
  const [currentLang, setCurrentLanguage] = React.useState('');

  const screenName = router?.pathname;
  const ae_web_scheduled_express = flagsmith.getValue(SCHEDULED_EXPRESS_FLAG, { json: true });
  const scheduledExpressEnabled = ae_web_scheduled_express?.isSheduledExpress;
  const pomFlag = flagsmith.getValue(FLAGSMITH_KEYS.POM_PRODUCT_FLAG, { json: true });
  const isPOMEnabled = pomFlag?.enabled && hasRX;
  const web_feature_flaging = flagsmith.getValue(FLAGSMITH_KEYS.WEB_FEATURE_FLAGING, {json: true});

  React.useEffect(() => {
    if(window !== 'undefined'){
      setCurrentLanguage(getLangCodeFromUrl());
    }
  }, []);

  React.useEffect(() => {
    if (wishListSkuIds) {
      setIsInWishList(wishListSkuIds?.find((skuId) => skuId === sku));
    }
  }, [wishListSkuIds, sku]);

  React.useEffect(() => {
    if (currency) {
      setPCurrency(currency);
    } else if (currencyAppConfig) {
      setPCurrency(currencyAppConfig);
    }
  }, [currencyAppConfig, currency]);

  React.useEffect(() => {
    if (appConfigData) {
      setRatingsEnable(getConfigurationActiveValueByName(appConfigData, PRODUCT_RATINGS_FLAG));
    }
  }, [appConfigData?.length]);

  // previously for check product in wishlist there was presentInWishlist flag not it change with above data;
  // useEffect(() => {
  //   setIsInWishList(product?.presentInWishlist || false);
  // }, [product?.presentInWishlist]);

  const zoneData = useSelector((state) => state?.app?.userLocationReducer?.zone);
  const cartData = useSelector((state) => state?.epharmacy?.getCartDetails?.data?.body);
  const getCartV2Data = useSelector((state) => state?.epharmacy?.getCartDetails?.data?.body);

  const getPageId = () => {

    let params = {};
    if (router?.query?.categories?.length === 2) {
      params.pageId = router?.query?.categories[1];
    } else if (router?.query?.categories?.length === 1) {
      params.pageId = router?.query?.categories[0];
    } else if (router?.query?.brands?.length === 2) {
      params.pageId = router?.query?.brands[1];
    } else if (router?.query?.brands?.length === 1) {
      params.pageId = router?.query?.brands[0];
    }

    return params;
  };

  const redirectToLogin = () => {
    sendLoginEvent(router.asPath);
    authCtx.login({
      redirectUri: `${REDIRECT_URI}${generateURL(`?asPath=${encodeURIComponent(router.asPath)}`)}`,
    });
  };

  const LoginCheck = () => {
    if (!authCtx?.authenticated) {
      setShowLoginModal(true);
      return false;
    }
    return true;
  };

  const triggerSearchtermApi = (product) => {
    const reqParams = {
      searchKeyword: product?.name,
      categoryName: product?.categoryName || '',
      searchFilterKey: '',
      type: product?.type || '',
      moduleType: 'Epharmacy',
      specialization: product?.specialization || '',
      id: product?.productId || '',
      uriPath: '',
      zone: localStorage.getItem('userZone'),
    };
    dispatch(searchTermInsertion({
      params: reqParams,
      onSuccess: (response) => {
          const params = {
            correlationId: response?.correlationId,
            clickedOn: product?.sku,
            clickType: 'PRODUCT',
            type: 'products',
            moduleType: 'Epharmacy'
          };
          dispatch(searchTermProductInsertion({
            params: params,
            onSuccess: (response) => {},
            onFailure: (err) => {
              errorHandling(err, true);
            },
          }))
      },
      onFailure: (err) => {
        errorHandling(err, true);
      },
    }))
  }

  const addIntoWishlist = () => {
    if (LoginCheck()) {
      const params = {
        sku: [sku],
        userId: userLogin?.id,
        cart_type: CART_TYPES.AE,
        wishlist_type: WISHLIST_TYPES.AE,
        wishlist_name: "Shopping List 1", //TODO: for now we are keeping it as hard coded will change later, discussed with shivendra 
        is_default: true
      };
      if (userZoneData) {
        params.zones = userZoneData;
      }
    
      dispatch(
        addToWishList({
          params,
          onSuccess: (response) => {
            wishlistAddRemoveGAEvent(WISHLIST_GA_EVENT.ADD_TO_WISHLIST, product, {
              item_list_name: itemListName,
            });
            sendEventToSmartLook('add_to_wishlist', 'add_to_wishlist');
            setIsInWishList(true);
            EventEmitter.dispatch('fetchWishList', {zone: userZoneData, userLogin});
            if (isMyCartPage) {
              EventEmitter.dispatch('fetchCartDetails', { cartIdParam: cartData?.cart_id });
              EventEmitter.dispatch('updateCarouselData');
            }
            if (response.status === 200) {
              if(isPdpQuickView) {
                toast.success(response?.body?.message ?? '')
              } else {
                EventEmitter.dispatch('setToastControlMessage', { message: response?.body?.message ?? '' });
              }
            } else {
              toast.error(response?.data ? response?.data : '');
            }
          },
          onFailure: (err) => {
            errorHandlingEpharmacy(err, true, screenName, pageType);
            toast.error(err?.data ? err?.data : '');
          },
        }),
      );
    }
  };
  const removeFromWishlist = () => {
    if (LoginCheck()) {
      const params = {
        sku: [sku],
        zones : userZoneData,
        cart_type: CART_TYPES.AE,
        wishlist_type: WISHLIST_TYPES.AE,
        userId: userLogin?.id,
      };
      dispatch(
        removeFromWishList({
          params,
          onSuccess: (response) => {
            setIsInWishList(false);
            wishlistAddRemoveGAEvent(WISHLIST_GA_EVENT.REMOVE_FROM_WISHLIST, product, {
              item_list_name: itemListName,
            });
            sendEventToSmartLook('remove_from_wishlist', 'remove_from_wishlist');
            EventEmitter.dispatch('fetchWishList', {zone: userZoneData, userLogin});
            if (isMyCartPage) {
              EventEmitter.dispatch('fetchCartDetails', { cartIdParam: cartData?.cart_id });
              EventEmitter.dispatch('updateCarouselData');
            }
            if (response.status === 200) {
              if(isPdpQuickView) {
                toast.success(response?.body?.message ?? '')
              } else {
                EventEmitter.dispatch('setToastControlMessage', { message: response?.body?.message ?? '' });
              }
            } else {
              toast.error(response?.data ? response?.data : '');
            }
          },
          onFailure: (err) => {
            errorHandlingEpharmacy(err, true, screenName, pageType);
            toast.error(err?.data ? err?.data : '');
          },
        }),
      );
    }
  };
  const onProductCardClick = (products) => {
    triggerSearchtermApi(products);
    const asterBadge = product?.badgeDetails?.asterBadge;
    const lowestPriceLabel = product?.lowestPriceLabel;

  let badgeContents = [];

  if (Array.isArray(asterBadge)) {
    badgeContents = asterBadge?.map((badge) => badge.content);
  } else if (asterBadge) {
    badgeContents = [asterBadge.content];
  }

  const formattedLowestPriceLabel = lowestPriceLabel?.replace(/<\/?b>/g, '');
  if (formattedLowestPriceLabel) {
    badgeContents.push(formattedLowestPriceLabel);
  }
    let categoryBrandType;
    let currentCartItem = getCartV2Data?.itemsToCart?.filter((cartItem) => cartItem?.sku === products?.sku); // TODO: check on this for wishlist
    if (isMyCartPage) {
      currentCartItem = cartData?.delivery_groups?.filter((cartItem) => cartItem?.sku === sku);
    }
    if (router.asPath.indexOf('/c') > -1) {
      categoryBrandType = 'Category';
    } else if (router.asPath.indexOf('/brand') > -1) {
      categoryBrandType = 'Brand';
    } else {
      categoryBrandType = 'Category';
    }
    sendProductViewEvent(
      { ...products },
      {
        item_list_id: itemListId,
        item_list_name: itemListName,
        index,
        promotion_name: badgeContents?.length>0 ? badgeContents :null,
        promotion_value_tag: product?.badgeDetails?.offerBadge ? `${product?.badgeDetails?.offerBadge}% Off!` : null,
        screen_name: pageName,
        page_id: getPageId()?.pageId || product?.sku,
        page_type:pageType?.toLowerCase(),
        referrer_page: referrerPage,
        section_name:sectionName==="Product Details Page - FBT" || sectionName=== "Product Listing page" ? null : sectionName,
      },
      categoryBrandType,
    );
  };

  const callSelectItemEvent = () => {
    const asterBadge = product?.badgeDetails?.asterBadge;
    const lowestPriceLabel = product?.lowestPriceLabel;

    let badgeContents = [];

    if (Array.isArray(asterBadge)) {
      badgeContents = asterBadge?.map((badge) => badge.content);
    } else if (asterBadge) {
      badgeContents = [asterBadge.content];
    }

    const formattedLowestPriceLabel = lowestPriceLabel?.replace(/<\/?b>/g, '');
    if (formattedLowestPriceLabel) {
      badgeContents.push(formattedLowestPriceLabel);
    }
    const params = {
      page_type: router?.asPath?.includes('searchresult') ? 'search result page' : 'product listing page',
      myaster_category: 'epharmacy',
      ecommerce: {
        items: [
          {
            ...getProductItemObjectEventFillersSelect(product),
          },
        ],
      },
      availability: !product?.inStock ? ASTER_PRODUCT_AVAILABILITY.OUT_OF_STOCK : ASTER_PRODUCT_AVAILABILITY.IN_STOCK,
      product_type: 'optics',
      product_sku: product?.sku,
      delivery_promise: product?.deliverByV2 || product?.deliverBy || null,
      express_availability: product?.express_bool ? 'true' : 'false',
      referrer_page: referrerPage,
      product_name: product?.name,
      screen_name: router?.pathname?.includes('searchresult') ? 'pharma search result' : pageName,
      page_id: null,
      bundle_deal_availability: product?.isBundled ? 'true' : 'false',
      promotion_name: badgeContents?.length > 0 ? badgeContents : null,
      promotion_value_tag: product?.badgeDetails?.offerBadge ? `${product?.badgeDetails?.offerBadge}% Off!` : null,
      section_name:
        sectionName === 'Product Details Page - FBT' || sectionName === 'Product Listing page' ? null : sectionName,
      currency: getCurrency(getDataFromCookie('regionCode')),
    };
    dataLayerSendEvent('select_item', params);
  };

  const EssentialProductDetail = (e, pathName) => {
    e.preventDefault();
    if(product?.showViewDetails){
      callSelectItemEvent();
    } else {
      onProductCardClick(product);
    }
    router.push({
      pathname: generateURL(pathName),
    });
  };

  const removeDecimalPoints = (x) => {
    if (parseInt(String(x)?.split('.')?.pop(), 10) === 0) return parseInt(x, 10);
    return String(x)?.split('')?.includes('.') ? Number?.parseFloat(x)?.toFixed(2) : x;
  };

  const pathName = getProductPath(product);
  // localStorage.setItem('canonical_url', pathName);
  // if (product?.customAttribute?.categoryIds) {
  //   pathName = pathName + '?categoryId=' + product?.customAttribute?.categoryIds?.split(',')[0];
  // }
  const customAttr = {};
  product?.customAttribute?.forEach((element) => {
    customAttr[element?.attributeCode] = element.value;
  });

  React.useEffect(() => {
    let charCount;
    if (window) {
      if (window.innerWidth < 980 && window.innerWidth > 767) {
        charCount = 65;
      } else if (window.innerWidth < 980) {
        charCount = 74;
      } else {
        charCount = 40;
      }
      setCharLimit(charCount);
    }
  }, []);

  const getDeliveryClass = () => {
    if (isPOMEnabled) return AE_GLOBAL.POM;
    if (isFlash && flashDeliveryFlag?.enabled) return AE_GLOBAL.FLASH;
    if (isScheduled && scheduledExpressEnabled) return AE_GLOBAL.SCHEDULED;
    if (express && (!flashDeliveryFlag?.enabled || !isFlash)) return AE_GLOBAL.EXPRESS;
    return '';
  };
  
  return (
    <ProductItemStyled
      isGlobalCarousel={props?.isGlobalCarousel}
      isBundle={isBundle}
      isPOMEnabled={isPOMEnabled}
      className={[classname, isInProductListingPage ? 'inProductList' : '', currentLang && isRTL(currentLang) ? 'rtl' : ''].join(' ')}
      isPdpQuickView={isPdpQuickView}
    >
      <div className="dealItemBox cursor-pointer" data-productid={sku}>
        <div className="item">
          <ProductBadges
            badgeDetails={badgeDetails}
            isInProductListingPage={isInProductListingPage}
            customProps={{ marginBottom: '6px' }}
            isPOMEnabled={isPOMEnabled}
            hasRX={hasRX}
          />
          {!getIsInstoreApp() && web_feature_flaging?.isWishlistEnable && (
            <div
              className={`addToWishList ${isInWishList ? 'alreadyin' : ''}`}
              onClick={() => (isInWishList ? removeFromWishlist() : addIntoWishlist())}
            >
              <Image
                src={isInWishList ? IC_BOOKMARK_CHECKED_GREEN.src : IC_BOOKMARK.src}
                alt=""
                width={14}
                height={18}
              />
            </div>
          )}
          <a href={generateURL(pathName)} onClick={(e) => EssentialProductDetail(e, pathName)} rel="noopener noreferrer">
            <div className="imgWrapper">
              <div className="img" data-test="div_2">
                <Image src={getImageUrlWithSize(categoryImage, 160, 160) || PRODUCT_CARD_DEFAULT.src} alt={name} width="160px" height="160px" unoptimized/>
              </div>
              <div className="discountEndsWrapper">
                {!outOfStock && (
                  <>
                    {isPOMEnabled && (
                      <div className="pomProduct">
                        <Image src={IC_POM_BADGE_CARDS} alt="pomProduct" className="pomProduct" />
                      </div>
                    )}
                    {isBundle && !isPOMEnabled && (
                      <div className="bundle-deal-cart">
                        <Image src={BUNDLE_DEAL_PDP_UPDATED} alt="Bundle_deal_cart" className="Bundle_deal_cart" />
                      </div>
                    )}
                    {lowestPriceLabel && !isBundle && !isPOMEnabled && (
                      <div className="lowestPriceLabel">
                        <div
                          className="lowestPriceLabeltitle"
                          dangerouslySetInnerHTML={{ __html: lowestPriceLabel }}
                        ></div>
                      </div>
                    )}
                    {!lowestPriceLabel &&
                      !isBundle && !isPOMEnabled &&
                      badgeDetails?.offerBadge > 0 &&
                      (customAttr?.special_to_date || product?.special_to_date) && (
                        <OfferTimeCounter time={new Date(customAttr?.special_to_date || product?.special_to_date)} />
                      )}
                  </>
                )}
                {ratingsEnable === 'true' && avgRating && Number(avgRating) > 0 && web_feature_flaging?.isRatingsReviewEnabled && (
                  <StarRatingNumberOnly ratings={avgRating} iconWidth="16px" iconHeight="16px" isProductCard={true}/>
                )}
              </div>
            </div>
            <h2 className="name" title={name} style={{textAlign: lang === 'ar' ? "right" : "left"}}>
              {name.length >= charLimit ? `${name.substr(0, charLimit).trim()}...` : name}
            </h2>
            {outOfStock && web_feature_flaging?.isCartEnable && (
              <div className="outofstock" style={{ margin: '0 0 8px 0', height: facetResponse?.oosData ? '20px' : 'auto' }}>
                {TEMPORARILY_OUT_OF_STOCK}
              </div>
            )}
            {product?.deliverByV2 && product?.deliveryTextV2 && (
              <div
                className={`delivery ${getDeliveryClass()}`}
                dangerouslySetInnerHTML={{__html: product?.deliveryTextV2.replace('{}',`<span class="delivery-text">${product?.deliverByV2}</span>`)}}
              />
            )}
            <div className="price" dir="ltr">
              {isPOMEnabled ? (
                <div className="new">
                  <div>{pCurrency}</div> <div>{removeDecimalPoints(actualPrice)}</div>
                </div>
              ) : newPrice && newPrice !== '' ? (
                <>
                  <div className="new">
                    <div>{pCurrency}</div> <div>{removeDecimalPoints(newPrice)}</div>
                  </div>
                  <div className="actual">
                    <div>{pCurrency}</div> <div>{removeDecimalPoints(actualPrice)}</div>
                  </div>
                </>
              ) : (
                <div className="new">
                  <div>{pCurrency}</div> <div>{removeDecimalPoints(actualPrice)}</div>
                </div>
              )}
            </div>
          </a>
          {!facetResponse?.oosData && typeof window !== 'undefined' &&
            <div className={`add-to-card ${currentLang && !isRTL(currentLang) ? 'ltr' : ''}`} style={currentLang && isRTL(currentLang) ? {left: '0px'} : {}}>
              <AddToCart
                getProductIndex={getProductIndex}
                isLoader={isLoader}
                sku={sku}
                colWidth={12}
                availableStock={availableStock}
                product={product}
                sourceContainerTitle={sourceContainerTitle}
                screenName={pageName}
                sectionName={sectionName}
                deliverBy={deliverBy}
                offer={offerBadge}
                isMyCartPage={isMyCartPage}
                isOptics={isOptics}
                itemListId={itemListId}
                itemListName={itemListName}
                index={index}
                onProductCardClick={onProductCardClick}
                pageType={pageType}
                screenType={screen}
                outOfStock={outOfStock}
                isBundle={isPOMEnabled ? false : isBundle}
                BundleDetails={BundleDetails}
                BundleImage={BundleImage}
                pageId={sku}
                productName={product?.name}
                referrerPage={referrerPage}
                newButton={true}
                shouldNotShowBundle={shouldNotShowBundle}
                emptySphValues={emptySphValues}
              />
            </div>
          }
        </div>
      </div>
      {showLoginModal && (
        <CustomModal
          bodyTextCenter
          footerBtnFullWidth
          modalTitle={t('EPharmacyHome.loginRegister')}
          size="md"
          footerAlignment="center"
          primaryButtonText={t('EPharmacyHome.loginRegister')}
          secondaryButtonText={t('EPharmacyHome.cancelBtnTitle')}
          primaryButtonClicked={() => redirectToLogin()}
          seconderyButtonClcked={() => setShowLoginModal(false)}
        >
          <p className="mb-0 font-17">{t('EPharmacyHome.pleaseLoginRegisterFirstToProceed')}</p>
        </CustomModal>
      )}
    </ProductItemStyled>
  );
};

ProductItem.propTypes = {
  categoryImage: PropTypes.string,
  name: PropTypes.string,
  newPrice: PropTypes.number,
  actualPrice: PropTypes.number,
  badgeDetails: PropTypes.object,
  express: PropTypes.bool,
  isFlash: PropTypes.bool,
  deliverBy: PropTypes.string,
  currency: PropTypes.string,
  outOfStock: PropTypes.bool,
  offerBadge: PropTypes.number,
  sku: PropTypes.string,
  availableStock: PropTypes.number,
  classname: PropTypes.string,
  sourceContainerTitle: PropTypes.string,
  product: PropTypes.object,
  isLoader: PropTypes.bool,
  isInProductListingPage: PropTypes.bool,
  deliveryText: PropTypes.string,
  pageName: PropTypes.string,
  sectionName: PropTypes.string,
  isMyCartPage: PropTypes.bool,
  itemListId: PropTypes.string,
  itemListName: PropTypes.string,
  index: PropTypes.number,
  screen: PropTypes.string,
  pageType: PropTypes.string,
  isScheduled: PropTypes.bool,
  avgRating: PropTypes.string,
  getProductIndex: PropTypes.func,
  hasRX: PropTypes.bool,
};

ProductItem.defaultProps = {
  categoryImage: '',
  name: '',
  sourceContainerTitle: '',
  isInProductListingPage: false,
  isMyCartPage: false,
  newPrice: 0,
  actualPrice: 0,
  badgeDetails: {},
  express: false,
  isScheduled: false,
  deliverBy: '',
  currency: '',
  outOfStock: false,
  offerBadge: 0,
  sku: '',
  availableStock: 1,
  classname: '',
  product: {},
  isLoader: false,
  deliveryText: '',
  pageName: '',
  sectionName: '',
  itemListId: '',
  itemListName: '',
  index: 0,
  screen: '',
  pageType: '',
  avgRating: '',
  isFlash: false,
  getProductIndex: () => {},
  hasRX: false,
};

export default ProductItem;
